import axios from 'axios';
import { serviceAccountErrorCallback } from 'api/callbacks';
import {
  EMPLOYEES,
  RESEND_INVITATION,
  EMPLOYEE,
  EMPLOYEES_SERVICE_V1_ID,
  ASSIGNED_STAFF,
  EMPLOYEES_SERVICE_V1,
  EMPLOYEES_SERVICE_EXPORT_V1,
  PERMISSIONS_V1,
  PERMISSIONS_LOGGEDIN_USER,
  ACTIVE_EMPLOYEES,
  EMPLOYEE_SLOT_V1_ID,
  OUTLETS_EMPLOYEES,
} from './constants';

// will be used for assign staff to slot and remove staff from slot
export function putSlotEmployeeV1({ data, params, slotId }) {
  return axios
    .put(EMPLOYEE_SLOT_V1_ID(slotId), data, { params })
    .catch(serviceAccountErrorCallback);
}

export function getActiveEmployees({ params }) {
  return axios
    .get(ACTIVE_EMPLOYEES, { params })
    .catch(serviceAccountErrorCallback);
}

export function getPermission({ userId, params }) {
  return axios
    .get(PERMISSIONS_V1(userId), { params, withCredentials: false })
    .catch(serviceAccountErrorCallback);
}

export function getLoggedInUserPermission(params) {
  return axios
    .get(PERMISSIONS_LOGGEDIN_USER, { params, withCredentials: false })
    .catch(serviceAccountErrorCallback);
}

export function getEmployeesServiceV1({ params }) {
  return axios
    .get(EMPLOYEES_SERVICE_V1, { withCredentials: true, params })
    .catch(serviceAccountErrorCallback);
}

export function getExportEmployeesServiceV1({ params }) {
  return axios
    .get(EMPLOYEES_SERVICE_EXPORT_V1, {
      withCredentials: false,
      params,
      headers: { 'Content-Type': 'application/csv' },
    })
    .catch(serviceAccountErrorCallback);
}

export function postEmployeesServiceV1({ data, params }) {
  return axios
    .post(EMPLOYEES_SERVICE_V1, data, { withCredentials: true, params })
    .catch(serviceAccountErrorCallback);
}

export function putEmployeesServiceV1({ data, params, id }) {
  return axios
    .put(EMPLOYEES_SERVICE_V1_ID(id), data, { params, withCredentials: false })
    .catch(serviceAccountErrorCallback);
}

export function deleteEmployeeServiceV1({ params, id }) {
  return axios
    .delete(EMPLOYEES_SERVICE_V1_ID(id), { params, withCredentials: false })
    .catch(serviceAccountErrorCallback);
}

export function getOutletsEmployees() {
  return axios
    .get(OUTLETS_EMPLOYEES, { withCredentials: true })
    .catch(serviceAccountErrorCallback);
}

function commonReject(error) {
  if (error.response) {
    let eobj;
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
    return Promise.reject(eobj);
  }
  return Promise.reject(new Error(error.message));
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L13
 * @param {object} params
 * @return {Axios.IPromise<U>}
 */
export function getEmployees(params) {
  return axios
    .get(EMPLOYEES, { params, withCredentials: true })
    .catch(commonReject);
}

export function getAssignedStaffV1(params) {
  return axios
    .get(ASSIGNED_STAFF, { params, withCredentials: true })
    .catch(err => {
      return Promise.reject(err.response);
    });
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L95
 * @param employeeId
 * @param params
 */
export function deleteEmployee(employeeId, params) {
  return axios
    .delete(EMPLOYEE(employeeId), { params, withCredentials: true })
    .catch(commonReject);
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L85
 * @param {object} data
 * @param {object} params
 * @return {Axios.IPromise<U>}
 */
export function postEmployee(data, params) {
  return axios
    .post(EMPLOYEES, data, { params, withCredentials: true })
    .catch(commonReject);
}

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/employees_controller.rb#L102
 * @param data
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function resendInvitation(data, params) {
  return axios
    .post(RESEND_INVITATION, data, { params, withCredentials: true })
    .catch(commonReject);
}
